<ng-container *ngIf="sectionRendered.type != TextImagesTypes.TERRE_CONTRASTES">
  <base-section [index]="index" [section]="section" *ngIf="sectionRendered.content || sectionRendered.gallery.length">
    <div class="grid grid-section col-gap-2xl row-gap-l text-image-container {{sectionRendered.type}}" [ngClass]="gridClass">
      <h2 class="h2" [innerHTML]="sectionRendered.title"
          *ngIf="
            sectionRendered.title && (sectionRendered.type == TextImagesTypes.FULL_IMAGE || sectionRendered.type == TextImagesTypes.FULL_IFRAME || sectionRendered.type == TextImagesTypes.FULL_INSTAGRAM)
        "></h2>
      <div class="content" *ngIf="sectionRendered.content || sectionRendered.title" [ngClass]="colContentClass">
        <h2 class="h2" [innerHTML]="sectionRendered.title"
            *ngIf="
            sectionRendered.title && (sectionRendered.type != TextImagesTypes.FULL_IMAGE && sectionRendered.type != TextImagesTypes.FULL_IFRAME && sectionRendered.type != TextImagesTypes.FULL_INSTAGRAM)
        "></h2>
        <div [innerHTML]="sectionRendered.content|safeHtml"></div>
      </div>
      <div class="medias" [ngClass]="colMediaClass" *ngIf="isInstagram || isIframe || (isImage && sectionRendered.gallery.length>0)">
        <ng-container *ngIf="isImage">
          <media-attachment
            data-aos="fade-up" data-aos-duration="1000"
            [sizeXL]="sizeXL"
            [sizeLG]="sizeLG"
            [sizeMD]="sizeMD"
            [sizeSM]="sizeSM"
            [sizeXS]="sizeXS"
            [attachment]="mediaId|attachmentFromId|async"
            [displayCopyright]="sectionRendered.type != TextImagesTypes.TWO_IMAGES_CENTER"
            *ngFor="let mediaId of sectionRendered.gallery"
          ></media-attachment>
        </ng-container>
        <ng-container *ngIf="isInstagram">
          <instagram-item [code]="sectionRendered.instagram"></instagram-item>
        </ng-container>
        <ng-container *ngIf="isIframe">
          <div class="iframe-container" [innerHTML]="'<iframe src=\''+sectionRendered.embed+'\'></iframe>'|safeHtml"></div>
        </ng-container>
      </div>
    </div>
    <ng-container *ngIf="(sectionRendered.selection_sit || sectionRendered.ids_sit) && hasSuggestion && (scIdsSit.length>0 || idsSit.length>0)">
      <div class="grid grid-section grid-cols-1 mt-10 overflow-auto gap-l">
          <div class="events-container col-span-1">
            <h3 class="h5" *ngIf="sectionRendered.suggestions_title!=''" [innerHTML]="sectionRendered.suggestions_title"></h3>
            <h3 class="h5" *ngIf="sectionRendered.suggestions_title==''" i18n="@@OurSuggestions">Nos suggestions</h3>
            <synapi-list-items (onTotalChange)="onSuggestionTotal($event)"
                               [standalone]="true"
                               [pagecountMax]="5"
                               [col]="5"
                               [scrollHorizontal]="true"
                               [size]="sectionRendered.nb_items_sit"
                               [scids]="scIdsSit"
                               [ids]="idsSit"
                               [ngClass]="{'list-without-map':true}"
            ></synapi-list-items>
          </div>
      </div>
    </ng-container>
  </base-section>
</ng-container>
<terre-constrastes-section [index]="index" [section]="section" *ngIf="sectionRendered.type == TextImagesTypes.TERRE_CONTRASTES"></terre-constrastes-section>

